import styled from "styled-components";
import {SIZES} from "@/components/constants";
import Item01Pc from "@public/assets/main/logistic-01-pc.png"
import Item01Mo from "@public/assets/main/logistic-01-mo.png"

import GridItem01Pc from "@public/assets/main/grid-item-01-pc.png"
import GridItem01Mo from "@public/assets/main/grid-item-01-mo.png"
import GridItem02Pc from "@public/assets/main/grid-item-02-pc.png"
import GridItem02Mo from "@public/assets/main/grid-item-02-mo.png"

const LogisticSection = ({data}) => {
    return(
        <SectionWrap>
            <div className={"container"}>
                <h2 className={"text-box"} dangerouslySetInnerHTML={{__html: data["main-pr2-title1"]}}/>
                <img src={data["main-pr2-pc-img1"]} alt={"용기 설명 이미지 pc"} className={"container-img-pc"}/>
                <img src={data["main-pr2-mo-img1"]} alt={"용기 설명 이미지 mo"} className={"container-img-mo"}/>
            </div>
            <div className={"container"}>
                <h2 className={"text-box"} dangerouslySetInnerHTML={{__html: data["main-pr2-title2"]}}/>
                <div className={"grid-wrap"}>
                    <div className={"grid-item"}>
                        <h4 className={"logistic-title"} dangerouslySetInnerHTML={{__html: data["service-pr2-img-title1"]}}/>
                        <img src={data["main-pr2-pc-img2"]} alt={"이전 서비스 이미지 pc"} className={"grid-item-img-pc"}/>
                        <img src={data["main-pr2-mo-img2"]} alt={"이전 서비스 이미지 mo"} className={"grid-item-img-mo"}/>
                    </div>
                    <div className={"grid-item"}>
                        <h4 className={"logistic-title highlights"} dangerouslySetInnerHTML={{__html: data["service-pr2-img-title2"]}}/>
                        <img src={data["main-pr2-pc-img3"]} alt={"현재 서비스 이미지 pc"} className={"grid-item-img-pc"}/>
                        <img src={data["main-pr2-mo-img3"]} alt={"현재 서비스 이미지 mo"} className={"grid-item-img-mo"}/>
                    </div>
                </div>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 80px 0;
    background-color: #f1f3f7;
    display: flex;
    flex-direction: column;
    gap: 120px;

    .container {
        display: flex;
        flex-direction: column;
        padding: 0 24px;
        margin: 0 auto;
        gap: 20px;
        width: 100%;

        .container-img-mo {
            display: none;
        }
        .grid-item-img-mo{
            display: none;
        }
        .text-box{
            font-weight: 700;
            line-height: 28px;
            font-size: 18px;
        }
        .green{
            color: #07903a;
        }

        .grid-wrap{
            display: grid;
            grid-template-columns: repeat(1, minmax(0, 1fr));
            column-gap: 36px;
            row-gap: 51px;
            .grid-item{
                display: flex;
                align-items: center;
                flex-direction: column;
                .logistic-title{
                    padding: 30px 0 15px 0;
                    text-align: center;
                    font-size: 16px;
                    line-height: 28px;
                    color: #5f5d67;
                    &.highlights{
                        font-weight: 700;
                        color: #07903a;
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
        }
    }

    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
            .grid-wrap{
                grid-template-columns: repeat(2, minmax(0, 1fr));
                .grid-item{
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    gap: 12px;
                    .logistic-title{
                        line-height: 40px;
                        font-size: 22px;
                    }
                    img{
                        height: 100%;
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        gap: 133px;
        .container {
            max-width: 1024px;
            padding: 0 40px;
            gap: 70px;
            .text-box{
                font-size: 40px;
                line-height:  64px;
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
    @media (max-width: ${SIZES.MOBILE_L}) {
        .container{
            .container-img-pc{
                display: none;
            }
            .grid-item-img-pc{
                display: none;
            }
            .container-img-mo {
                display: block;
            }
            .grid-item-img-mo{
                display: block;
            }
        }
    }
`
export default LogisticSection;